var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAirbus(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMinYMin meet",
    viewBox: "0 0 400 75",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AIRBUS_White",
    fill: "#ffffff",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.595,25.949 C184.595,12.467 175.75,2.22 157.522,2.22 L120.85,2.22 L120.85,73.083 L138.108,73.083 L138.108,17.535 L157.63,17.535 C164.857,17.535 167.444,21.635 167.444,26.38 C167.444,31.234 164.748,35.225 157.521,35.225 L140.803,35.225 L164.532,73.083 L184.163,73.083 C184.163,73.083 167.983,47.628 168.092,47.628 C178.124,45.256 184.595,38.245 184.595,25.949",
    id: "Path"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 91.944,
    y: 2.22,
    width: 17.258,
    height: 70.864
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "36.829 2.22 0.696 73.083 20.11 73.083 25.963 61.219 55.056 61.219 47.83 46.334 33.307 46.334 44.054 24.547 44.271 24.547 68.431 73.083 88.277 73.083 52.144 2.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.588,36.304 C253.09,33.283 256.002,28.43 256.002,21.311 C256.002,9.878 247.481,2.22 233.136,2.22 L192.794,2.22 L192.794,73.083 L234.754,73.083 C249.422,73.083 259.022,65.209 259.022,53.237 C259.021,44.933 254.384,38.677 247.588,36.304 L247.588,36.304 Z M210.054,17.212 L233.136,17.212 C236.588,17.212 239.284,19.908 239.284,23.468 C239.284,27.028 236.588,29.724 233.027,29.724 L210.053,29.724 L210.053,17.212 L210.054,17.212 Z M233.566,58.198 L210.053,58.198 L210.053,43.745 L233.566,43.745 C237.773,43.745 241.009,46.766 241.009,50.864 C241.01,55.07 237.773,58.198 233.566,58.198 L233.566,58.198 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.49,41.804 C313.49,52.56 308.528,58.522 298.714,58.522 C289.007,58.522 284.045,52.56 284.045,41.804 L284.045,2.22 L266.357,2.22 L266.357,40.51 C266.357,62.406 277.898,74.594 298.714,74.594 C319.53,74.594 331.179,62.406 331.179,40.51 L331.179,2.22 L313.49,2.22 L313.49,41.804 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.234,30.371 C360.851,26.382 357.281,26.001 357.281,21.31 C357.281,17.681 361.379,15.917 368.282,15.917 C377.45,15.917 387.213,18.217 392.766,21.634 L398.267,7.181 C391.149,3.406 380.686,0.709 368.498,0.709 C350.269,0.709 340.022,9.77 340.022,21.957 C340.022,35.071 347.676,40.399 365.261,44.176 C378.951,47.194 381.87,49.077 381.87,52.912 C381.87,57.078 378.096,58.953 370.654,58.953 C359.868,58.953 350.106,56.333 342.287,52.05 L337.002,67.15 C345.523,71.68 358.25,74.593 371.085,74.593 C388.99,74.593 399.667,66.287 399.667,52.373 C399.669,41.21 392.447,34.039 377.234,30.371",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirbus);
export default __webpack_public_path__ + "static/media/airbus.426c2a4e59fc6e5ce27c2c749c735189.svg";
export { ForwardRef as ReactComponent };